﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";

import {TableColumnType} from "./TableColumnType";

// Only the styling-relevant subset of a column's props. Decoupled from the full
// (generic) TableColumnProps union so `any` row types don't trip up the variance
// of the strongly-typed `cell`/`render` members.
interface ColumnStyleProps {
	align?: "left" | "right" | "center";
	className?: string;
	type?: TableColumnType;
}

function addClassName(calc: string, props: ColumnStyleProps) {
	if (isNullOrEmpty(props.className)) {
		return calc;
	}

	return `${calc} ${props.className}`;
}

function getColumnType(props: ColumnStyleProps): string {
	if (!isNullOrEmpty(props.align)) {
		return props.align;
	}

	switch (props.type) {
		case TableColumnType.Text:
			return "text";

		case TableColumnType.TruncatedText:
			return "truncated-text";

		case TableColumnType.Number:
			return "number";

		case TableColumnType.Date:
			return "date";

		case TableColumnType.Boolean:
			return "bool";

		case TableColumnType.Actions:
			return "actions";

		case TableColumnType.NoWrap:
			return "shrink";
	}

	return "";
}

export function columnType(props: ColumnStyleProps): string {
	return addClassName(getColumnType(props), props);
}
